<template>
  <v-card flat>
    <!-- Скелетон для загрузки -->
    <template v-if="isLoading">
      <v-card-text class="form-wrapper">
        <div v-for="i in 5" :key="i" class="form-row">
          <div class="form-label">
            <v-skeleton-loader type="text" width="100" />
          </div>
          <v-skeleton-loader type="text" width="100%" />
        </div>
      </v-card-text>
    </template>

    <!-- Ошибка -->
    <template v-else-if="hasError">
      <v-card-text>
        <v-alert
          type="error"
          variant="tonal"
          closable
          @click:close="hasError = false"
        >
          {{ errorMessage || "Ошибка загрузки данных" }}
        </v-alert>
      </v-card-text>
    </template>

    <template v-else>
      <v-card-text class="form-wrapper">
        <div class="form-row">
          <div class="form-label">Телефон</div>
          <v-mask-input
            v-model="student.phone1"
            variant="outlined"
            density="compact"
            mask="+7(###)-###-##-##"
            placeholder="+7(___)-___-__-__"
            validate-on="blur"
            @update:modelValue="onStudentUpdate"
          />
        </div>

        <div class="form-row">
          <div class="form-label">Дополнительный телефон</div>
          <v-mask-input
            v-model="student.phone"
            variant="outlined"
            density="compact"
            mask="+7(###)-###-##-##"
            placeholder="+7(___)-___-__-__"
            validate-on="blur"
            @update:modelValue="onStudentUpdate"
          />
        </div>

        <div class="form-row">
          <div class="form-label">Email</div>
          <v-text-field
            v-model="student.email"
            variant="outlined"
            density="compact"
            :rules="emailRules"
            type="email"
            placeholder="example@mail.com"
            validate-on="blur"
            @update:modelValue="onStudentUpdate"
          />
        </div>

        <div class="form-row">
          <div class="form-label">Адрес регистрации</div>
          <addressDetails
            class="address-details"
            :addressId="student.reg_addr_id"
            @update:addressId="onAddressUpdate('reg_addr_id', $event)"
          />
        </div>

        <div class="form-row">
          <div class="form-label">Адрес проживания</div>
          <addressDetails
            class="address-details"
            :addressId="student.live_addr_id"
            @update:addressId="onAddressUpdate('live_addr_id', $event)"
          />
        </div>
      </v-card-text>
    </template>
  </v-card>
</template>

<script>
import { VMaskInput } from "vuetify/labs/VMaskInput";
import addressDetails from "./addressDetails.vue";

export default {
  name: "ContactDetails",

  components: {
    addressDetails,
    VMaskInput,
  },

  props: {
    student: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isLoading: false,
      hasError: false,
      errorMessage: null,

      emailRules: [(v) => !v || /.+@.+\..+/.test(v) || "Некорректный email"],
    };
  },

  methods: {
    onStudentUpdate() {
      this.$emit("update:student", this.student);
    },

    onAddressUpdate(field, value) {
      this.student[field] = value;
      this.onStudentUpdate();
    },
  },
};
</script>